<template>
  <vx-tooltip text="Написать комментарий">
    <vs-dropdown vs-trigger-click>
      <button class="messenger-buttons__item">
        <feather-icon
          icon="MessageCircleIcon"
        />
      </button>
      <vs-dropdown-menu>
        <div class="dropdown-custom">
          <h5 class="mb-6">Добавить внутренний комментарий</h5>
          <div class="mb-6">
            <vs-textarea
              v-model="addingCommentText"
              placeholder="Введите комментарий"
            />
          </div>
          <vs-button
            :disabled="addingCommentText === ''"
            @click.prevent="onAddComment"
          >
            Добавить
          </vs-button>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </vx-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

import InternalComment from '@/api/http/models/InternalComment'

export default {
  data () {
    return {
      addingCommentText: ''
    }
  },

  computed: mapGetters(['authUserCompany', 'currentClient']),

  methods: {
    onAddComment () {
      const send = async () => {
        const response = await InternalComment.add(this.authUserCompany.slug, this.currentClient.client_id, {
          comment: this.addingCommentText
        })
        if (response.status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Комментарий успешно добавлен',
            text: ''
          })
          this.addingCommentText = ''
        } else if (response.status === 'not_permitted') {
          this.$vs.notify({
            color: 'danger',
            title: 'Операция недоступна',
            text: ''
          })
        }
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Добавить комментарий?',
        text: `«${this.addingCommentText}»`,
        accept: send,
        acceptText: 'Добавить',
        cancelText: 'Отменить'
      })
    }
  }
}
</script>
